import { groupPermissionStore } from 'stores/groupPermissionStore'

export const setGroupPermissionAccess = (permissions: any) => {
  groupPermissionStore.setState({ homePermission: permissions.homePermission })
  groupPermissionStore.setState({
    clientManagementPermission: permissions.clientManagementPermission,
  })
  groupPermissionStore.setState({
    clientManagement_LicensedEstablishmentsPermission:
      permissions.clientManagement_LicensedEstablishmentsPermission,
  })
  groupPermissionStore.setState({
    clientManagement_OrganizationsPermission:
      permissions.clientManagement_OrganizationsPermission,
  })
  groupPermissionStore.setState({
    clientManagement_CorporateAccountsPermission:
      permissions.clientManagement_CorporateAccountsPermission,
  })
  groupPermissionStore.setState({
    clientManagement_LEConnectUsersPermission:
      permissions.clientManagement_LEConnectUsersPermission,
  })
  groupPermissionStore.setState({
    patronAccountsPermission: permissions.patronAccountsPermission,
  })
  groupPermissionStore.setState({
    rewardsPermission: permissions.rewardsPermission,
  })
  groupPermissionStore.setState({
    rewards_RewardProgramsPermission:
      permissions.rewards_RewardProgramsPermission,
  })
  groupPermissionStore.setState({
    rewards_RewardCatalogsPermission:
      permissions.rewards_RewardCatalogsPermission,
  })
  groupPermissionStore.setState({
    rewards_RewardItemsPermission: permissions.rewards_RewardItemsPermission,
  })
  groupPermissionStore.setState({
    promotionsPermission: permissions.promotionsPermission,
  })
  groupPermissionStore.setState({
    contestsPermission: permissions.contestsPermission,
  })
  groupPermissionStore.setState({
    contests_SweepstakesPermission: permissions.contests_SweepstakesPermission,
  })
  groupPermissionStore.setState({
    contests_LocationSweepstakesPermission:
      permissions.contests_LocationSweepstakesPermission,
  })
  groupPermissionStore.setState({
    contests_PassportGamesPermission:
      permissions.contests_PassportGamesPermission,
  })
  groupPermissionStore.setState({
    contests_BadgeRewardsPermission:
      permissions.contests_BadgeRewardsPermission,
  })
  groupPermissionStore.setState({
    contests_LocationsBadgeRewardsPermission:
      permissions.contests_LocationsBadgeRewardsPermission,
  })
  groupPermissionStore.setState({
    communicationsPermission: permissions.communicationsPermission,
  })
  groupPermissionStore.setState({
    communications_MessagesPermission:
      permissions.communications_MessagesPermission,
  })
  groupPermissionStore.setState({
    communications_BannersPermission:
      permissions.communications_BannersPermission,
  })
  groupPermissionStore.setState({
    jjUpdatesPermission: permissions.jjUpdatesPermission,
  })
  groupPermissionStore.setState({
    settingsPermission: permissions.settingsPermission,
  })
  groupPermissionStore.setState({
    supportToolsPermission: permissions.supportToolsPermission,
  })
  groupPermissionStore.setState({ permissionsLoaded: true })
}
